import { render, staticRenderFns } from "./resultat-nfs.html?vue&type=template&id=55a72c21&scoped=true&external"
import script from "./resultat-nfs.js?vue&type=script&lang=js&external"
export * from "./resultat-nfs.js?vue&type=script&lang=js&external"
import style0 from "./resultat-nfs.scss?vue&type=style&index=0&id=55a72c21&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a72c21",
  null
  
)

export default component.exports